import React, { useEffect, useState } from "react";
import styles from '../../programDirector/createInstructor/CreateInstructor.module.scss';
import pcStyles from './CreateProgramCoordinator.module.scss';
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import ProgramCoordinatorForm from "../../../components/programCoordinatorForm/ProgramCoordinatorForm";
import Button from "../../../components/button/Button";
import axiosClient from "../../../api/axiosClient";
import { useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import { useToasts } from "../../../contexts/ToastContext";
import { formatPhoneNumber } from "../../../utils/stringUtils";

const CreateProgramCoordinator = () => {
  const [isLoading, setIsLoading] = useState(false);
  const initialFormData = {
    profilePicture: null,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    programIds: [],
  };
  const [formData, setFormData] = useState(initialFormData);
  const [programList, setProgramList] = useState([]);
  const { coordinatorId } = useParams();
  const { showToast } = useToasts();
  const navigate = useNavigate();

  useEffect(() => {
    axiosClient.get('programs').then((response) => {
      if (response.data?.programs) {
        setProgramList(response.data.programs.map((item) => ({ value: item.id, label: item.title })));
      }
    });
  }, []);

  useEffect(() => {
    if (!coordinatorId) return;
    setIsLoading(true);
    axiosClient.get(`users/program-coordinator/${coordinatorId}`)
      .then((response) => {
        setFormData((prev) => ({
          ...prev,
          profilePicture: response.data?.profilePicture,
          firstName: response.data?.firstName,
          lastName: response.data?.lastName,
          email: response.data?.email,
          phone: response.data?.phone !== '0' ? formatPhoneNumber(response.data?.phone) : '',
          programIds: response.data?.programs?.map(item => item.id) ?? [],
        }));
      })
      .catch((error) => showToast(error.message, 'error'))
      .finally(() => setIsLoading(false));
  }, [coordinatorId, showToast]);

  const handleSave = async (imageFile) => {
    const data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      mobileNumber: formData.phone.replace(/\D/g, ''),
      programIds: formData.programIds,
    };
    const updatedFormData = new FormData();
    for (let key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (Array.isArray(data[key])) {
          data[key].forEach(item => {
            if (item != null) updatedFormData.append(`${key}[]`, item);
          });
        } else {
          if (data[key] != null) updatedFormData.append(key, data[key]);
        }
      }
    }
    if (imageFile) updatedFormData.append('profilePicture', imageFile);

    setIsLoading(true);
    const url = coordinatorId
      ? `users/program-coordinator/${coordinatorId}`
      : 'program-coordinator/create';
    const method = coordinatorId ? 'patch' : 'post';

    await axiosClient[method](url, updatedFormData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then((response) => {
        showToast(response.message);
        navigate('/program-coordinators');
      })
      .catch((error) => showToast(error.message, 'error'))
      .finally(() => {
        setIsLoading(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  };

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={`${styles.breadcrumbs} ${pcStyles.breadcrumbRow}`}>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Program Coordinator Management', path: '/program-coordinators' },
            { label: coordinatorId ? 'Edit Program Coordinator' : 'Create Program Coordinator' }
          ]}
        />
        {coordinatorId && (
          <Button
            label="Permissions"
            variant="primary-light"
            size="small"
            onClick={() => navigate(`/program-coordinators/permissions/${coordinatorId}`)}
          />
        )}
      </div>
      <div className={styles.container}>
        <ProgramCoordinatorForm
          formData={formData}
          programList={programList}
          isEdit={!!coordinatorId}
          onDataChange={(updatedData) => setFormData((prev) => ({ ...prev, ...updatedData }))}
          onSubmit={handleSave}
        />
      </div>
    </>
  );
};

export default CreateProgramCoordinator;
